(function() {
  'use strict';
  angular.module('benefits', ['common', 'ngResource', 'ngSanitize',
    'ui.grid.resizeColumns',
    'ui.grid.selection',
    'ui.grid.pinning',
    'ui.grid.exporter',
    'ui.grid.moveColumns',
    'ui.grid.autoResize'])
  .run(["$templateCache", '$http', function($templateCache, $http) {
    // Caching hack since uib-accordian will only allow static template URLs
    let templates = ['/js/benefits/accordionTemplate.html',
      '/js/benefits/accordionGroup.html'];
    _.each(templates,(templateUrl) => {
      $http.get(templateUrl + appVersion).then((response) => {
        $templateCache.put(templateUrl, response.data);
      });  
    });
  }]);
})();